import { RefObject, useEffect, useRef } from 'react'

export const useClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  callback: () => void,
  ...additionalRefs: RefObject<HTMLElement | null | undefined>[]
) => {
  const callbackRef = useRef(callback)

  callbackRef.current = callback

  useEffect(() => {
    const handleClickOutside = (ev: MouseEvent) => {
      const target = ev.target as Node
      const refs = [ref, ...additionalRefs]

      if (refs.some(item => item.current?.contains(target))) {
        return
      }

      callbackRef.current()
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // Ref objects are stable; .current is read at event time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
